export const reportError = console.error;